module.exports = __webpack_public_path__ + "static/media/cancel.66321440.svg";